const AuthRoutes = {
  login: 'Token',
  register: 'api/Account/REgister',
  verifyToken: 'api/Account/REgister',
  getUsers: 'api/User/GetUsersList',
};

export default AuthRoutes